import { Button } from '@/components/Button/Button'
import { Popup } from '@/components/Popup/Popup'
import type { FunctionalComponent } from 'preact'

export const QuotaPopup: FunctionalComponent<{
  onClose: () => void
}> = props => {
  return (
    <Popup
      width={600}
      onClose={props.onClose}
    >
      <Popup.Title>
        Limits
      </Popup.Title>

      <Popup.Fields>
        <Popup.Msg>
          We’re currently in beta.<br />
          You can generate up to 30 posts per month.<br />
          Need more? <a href='mailto:sudokey@gmail.com'>Email</a> me or reach out{' '}
          <a href='https://x.com/sudokey' target='_blank'>on X</a>{' '}
          and I’ll increase your limit.<br />
        </Popup.Msg>
      </Popup.Fields>

      <Popup.Footer>
        <Popup.Buttons />
        <Popup.Buttons>
          <Button
            type='primary'
            onClick={props.onClose}
          >
            Got it
          </Button>
        </Popup.Buttons>
      </Popup.Footer>
    </Popup>
  )
}
